export var fonts = {
    vodafone: "Vodafone",
    regular: "VodafoneRg",
    light: "VodafoneLt",
    exbold: "VodafoneExB"
};
